import type { FormControl, ValidationErrors } from '@angular/forms';

const NUMBER_PATTERN = new RegExp('^(-*([0-9]+)|-*(([0-9]+).([0-9]+)))$');
const INTEGER_PATTERN = new RegExp('^(-*([0-9]+))$');

export function numberOfOpeningValidator(
  hiredCandidatesCount: number,
): (control: FormControl) => ValidationErrors | null {
  return (control: FormControl): ValidationErrors | null => {
    if (!control.value && control.value !== 0) return null;

    const isNumber = NUMBER_PATTERN.test(control.value);
    if (!isNumber) return { notNumber: true };

    const exceedsHiredCandidatesCount =
      Number(control.value) > 0 ? Number(control.value) >= hiredCandidatesCount : true;
    if (!exceedsHiredCandidatesCount) return { notExceedsHiredCandidatesCount: true };

    const isPositive = Number(control.value) > 0;
    if (!isPositive) return { notPositive: true };

    const isInteger =
      Number.isInteger(Number(control.value)) && INTEGER_PATTERN.test(control.value);
    return isInteger ? null : { notInteger: true };
  };
}
